import React, { useEffect } from "react";
import { Avatar, IconButton, Divider } from "@mui/material";
import { signIn, signOut } from "../../services/auth";
import { Login, Logout, Person } from "@mui/icons-material";
import { useState } from "react";
import ProfileMenu from "./profile-menu";
import { Link } from "react-router-dom";
import { MenuSubHeader } from "../nav-bar/navbar-items";
import PropTypes from "prop-types";
import IconNav from "../nav-bar/icon-nav";
//import { MdAccountCircle } from "react-icons/md";

function LoginButton({ user, isDrawer, handleDrawerClose, iconMenu }) {
    const loggedInUser = sessionStorage.getItem("user");
    const storedUser = loggedInUser ? JSON.parse(loggedInUser) : user;

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        if (storedUser) {
            if (storedUser.expiresAt < new Date().getTime()) {
                signOut();
            }
        }
    }, []);

    return (
        <>
            {!storedUser &&
                (isDrawer ? (
                    // only display in mobile navbar drawer
                    <MenuSubHeader title="Log In" icon={<Login />} onClick={signIn} />
                ) : (
                    // always display top left, mobile or desktop
                    <div className="d-flex align-items-center ">
                        {
                            iconMenu &&
                            <IconNav
                                //label="Log In"
                                label={iconMenu.subheader}
                                handleClick={signIn}>
                                {/*<MdAccountCircle />*/}
                                {iconMenu.icon}
                            </IconNav>
                        }
                    </div>
                ))}

            {storedUser &&
                (isDrawer ? (
                    // only display in mobile navbar drawer
                    <>
                        <MenuSubHeader
                            title="Profile"
                            icon={<Person />}
                            component={Link}
                            to="/profile"
                            onClick={handleDrawerClose}
                        />
                        <Divider />
                        <MenuSubHeader title="Log Out" icon={<Logout />} onClick={signOut} />
                        <Divider />
                    </>
                ) : (
                    // always display top left, mobile or desktop
                    <div className="d-flex align-items-center ms-2">
                        <IconButton
                            onClick={handleClick}
                            aria-controls={open ? "account-menu" : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? "true" : undefined}
                        >
                            <Avatar
                                alt="User Avatar"
                                src={storedUser.picture}
                                sx={{
                                    width: { xs: 40, lg: 50 },
                                    height: { xs: 40, lg: 50 }
                                }}
                            />
                        </IconButton>

                        {/* Avatar Menu */}
                        <ProfileMenu anchorEl={anchorEl} open={open} handleClose={handleClose} storedUser={storedUser} />
                    </div>
                ))}
        </>
    );
}

LoginButton.propTypes = {
    user: PropTypes.object,
    isDrawer: PropTypes.bool,
    handleDrawerClose: PropTypes.func,
    iconMenu: PropTypes.object.isRequired
};

export default LoginButton;